import { render, staticRenderFns } from "./HrDocumentAgreementDialog.vue?vue&type=template&id=389e8956&scoped=true&"
import script from "./HrDocumentAgreementDialog.vue?vue&type=script&lang=js&"
export * from "./HrDocumentAgreementDialog.vue?vue&type=script&lang=js&"
import style0 from "./HrDocumentAgreementDialog.vue?vue&type=style&index=0&id=389e8956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e8956",
  null
  
)

export default component.exports